/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Skeleton } from "@mui/material";
import axiosProtected from "../../../../../api/config/baseWithToken";

export default function AttentionData({windowWidth, disputeReturnedOrdersData, setDisputeReturnedOrdersData, storeOwner }) {
  const [loading, setLoading] = useState(false)
  const getReturnedOrdersAndDisputesAnalytics = async () => {
    try {
      setLoading(true)
      await new Promise(resolve => setTimeout(resolve, 1000));
      const { data } = await axiosProtected.get(
        "/store/dispute-returned-orders-analytics"
      );
      setDisputeReturnedOrdersData(data?.result);
    } catch (error) {
      console.log(error);
    }finally{
      setLoading(false)
    }
  };

  useEffect(() =>{
    if(!storeOwner){

      getReturnedOrdersAndDisputesAnalytics()
    }
  },[])


  const mappedOrders = loading  ? [1, 2] : disputeReturnedOrdersData?.orders;
  const mappedDisputes = loading ? [3, 4] : disputeReturnedOrdersData?.disputes;
  return (
    <div>
      {mappedOrders?.map((item) =>
        loading ? (
          <Skeleton
            variant="rounded"
            height={50}
            width="100%"
            sx={{ marginTop: "10px" }}
          />
        ) : (
          <div
            key={item._id}
            style={{
              borderRadius: "8px",
              // padding: "5px 10px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              backgroundColor: "#f3f4f8",
              marginTop: "10px",
            }}
          >
            <div>
              <h5
                style={{
                  marginTop: "10px",
                  fontSize: windowWidth <= 1500 ? "11px" : "14px",
                  lineHeight: "10px",
                }}
              >
                #{item?.order?.shopify_order_number}
              </h5>
              <small style={{ fontSize: windowWidth <= 1500 ? "10px" : "" }}>
                Returned
              </small>
            </div>
            <div>
              <h5
                style={{
                  marginTop: "10px",
                  fontSize: windowWidth <= 1500 ? "11px" : "14px",
                  lineHeight: "10px",
                }}
              >
                Deadline
              </h5>
              <small
                style={{
                  color:
                    item?.daysRemaining === 1
                      ? "red"
                      : item?.daysRemaining === 2
                      ? "orange"
                      : "",
                  fontSize: "12px",
                }}
              >
                {item?.daysRemaining === 0 || !item?.daysRemaining
                  ? "Today"
                  : item?.daysRemaining === 1
                  ? "in " + item?.daysRemaining + " day"
                  : item?.daysRemaining === 2
                  ? "in " + item?.daysRemaining + " days"
                  : "in " + item?.daysRemaining + " days"}
              </small>
            </div>
            <div
              style={{
                backgroundColor: "#e8def6",
                color: "#6546ab",
                padding: windowWidth <= 1500 ? "5px" : "5px 10px",
                borderRadius: "8px",
              }}
            >
              <Link
                to="/customer/orders/returned-to-overseas-warehouse"
                style={{ color: "#6546ab" }}
              >
                <h5 style={{ fontSize: windowWidth <= 1500 ? "11px" : "" }}>
                  Reply
                </h5>
              </Link>
            </div>
          </div>
        )
      )}
      {mappedDisputes?.map((item) =>
        loading ? (
          <Skeleton
            variant="rounded"
            height={50}
            width="100%"
            sx={{ marginTop: "10px" }}
          />
        ) : (
          <div
            key={item._id}
            style={{
              borderRadius: "8px",
              padding: "5px 10px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              backgroundColor: "#f3f4f8",
              marginTop: "10px",
            }}
          >
            <div>
              <h5
                style={{
                  marginTop: "10px",
                  fontSize: windowWidth <= 1500 ? "11px" : "14px",
                  lineHeight: "10px",
                }}
              >
                #{item?.order?.shopify_order_number}
              </h5>
              <small style={{ fontSize: windowWidth <= 1500 ? "10px" : "" }}>
                Disputes
              </small>
            </div>
            <div>
              <h5
                style={{
                  marginTop: "10px",
                  fontSize: windowWidth <= 1500 ? "11px" : "14px",
                  lineHeight: "10px",
                }}
              >
                {item.status === "pending" ? "Waiting" : "Waiting"}
              </h5>
              <small
              // style={{
              //   color:
              //     order.deadline === "in 1 day"
              //       ? "red"
              //       : order.deadline === "in 2 days"
              //       ? "orange"
              //       : "",
              // }}
              >
                since {item.sinceDays} {item.sinceDays > 1 ? "Days" : "Day"}
              </small>
            </div>
            <div
              style={{
                backgroundColor: "#e8def6",
                color: "#6546ab",
                padding: windowWidth <= 1500 ? "5px" : "5px 10px",
                borderRadius: "8px",
              }}
            >
              <Link
                to="/customer/orders/dispute-list"
                style={{ color: "#6546ab" }}
              >
                {" "}
                <h5 style={{ fontSize: windowWidth <= 1500 ? "11px" : "" }}>
                  Reply
                </h5>
              </Link>
            </div>
          </div>
        )
      )}
    </div>
  );
}
